import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/CourseDetails.css";

import { db } from "../Firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";

/* ================= FAQ ITEM ================= */
const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item ${open ? "open" : ""}`}>
      <div className="faq-question" onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <span className="faq-arrow">{open ? "⌃" : "⌄"}</span>
      </div>
      {open && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

/* ================= COURSE DETAILS ================= */
const CourseDetails = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [course, setCourse] = useState(null);
  const [rating, setRating] = useState(0);
  const [reviewsCount, setReviewsCount] = useState(0);
  const [learners, setLearners] = useState(0);
  const [loading, setLoading] = useState(true);




  /* ================= FETCH COURSE ================= */
  useEffect(() => {
    const fetchAll = async () => {
      try {
        /* -------- COURSE -------- */
        const courseSnap = await getDoc(doc(db, "courses", courseId));
        if (!courseSnap.exists()) return;

        const courseData = { id: courseSnap.id, ...courseSnap.data() };
        setCourse(courseData);

        /* -------- REVIEWS -------- */
        const reviewQ = query(
          collection(db, "reviews"),
          where("courseId", "==", courseId)
        );

        const reviewSnap = await getDocs(reviewQ);

        let totalRating = 0;
        reviewSnap.forEach(doc => {
          totalRating += doc.data().rating || 0;
        });

        setReviewsCount(reviewSnap.size);
        setRating(
          reviewSnap.size > 0
            ? (totalRating / reviewSnap.size).toFixed(1)
            : 0
        );

        /* -------- LEARNERS -------- */
        const orderQ = query(
          collection(db, "orders"),
          where("courseId", "==", courseId)
        );

        const orderSnap = await getDocs(orderQ);
        setLearners(orderSnap.size);

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [courseId]);

  if (loading) return <h2 style={{ padding: 40 }}>Loading...</h2>;
  if (!course) return <h2 style={{ padding: 40 }}>Course not found</h2>;

  return (
    <div className="course-details-page">

      {/* LEFT SIDE */}
      <div className="course-left">

        <h1 className="course-title">{course.title}</h1>

        <div className="course-meta">
          <div>⭐ {rating} ({reviewsCount} reviews)</div>
          <div>👥 {learners} learners</div>
          <div>⏱ {course.duration}</div>
        </div>

        <hr />

        <h2>Overview</h2>
        <p>{course.description || course.overview}</p>

        <hr />

        {/* ===== COURSE CONTENT ===== */}
        <h2 className="content-title">Course Content</h2>

        <div className="accordion">
          {course.videos?.map((v, i) => (
            <div key={v.id} className="accordion-item">
              <div className="accordion-header">
                <span>{i + 1}. {v.title}</span>
                <span className="arrow">🔒</span>
              </div>
              <div className="accordion-body">
                <p>Buy the course to unlock this video</p>
              </div>
            </div>
          ))}
        </div>

        <hr />

        {/* ===== FAQ ===== */}
        <h2 className="faq-title">Frequently Asked Questions</h2>

        <div className="faq">
          {course.faqs?.map((f, i) => (
            <FAQItem key={i} question={f.q} answer={f.a} />
          ))}
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="course-right">
        <div className="course-card">

          {/* SAMPLE VIDEO */}
          {course.previewVideo && (
            <>
              <h2 className="content-title">Sample Video</h2>

              <div className="video-card">
                <video controls poster={course.thumbnail}>
                  <source
                    src={course.previewVideo}
                    type="video/mp4"
                  />
                </video>
              </div>
            </>
          )}

          <p className="price">
            <strong>Price:</strong>{" "}
            {course.price === 0 ? "Free" : `₹${course.price}`}
          </p>

          <button
            className="cart-btn"
            onClick={() => {
              const cart = JSON.parse(localStorage.getItem("cart")) || [];
              localStorage.setItem("cart", JSON.stringify([...cart, course]));
              navigate("/cart");
            }}
          >
            Add to Cart
          </button>

          <button
            className="enroll-btn"
            onClick={() => navigate(`/checkout/${course.id}`)}
          >
            Enroll / Buy Now
          </button>

        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
